/* eslint-disable no-param-reassign */
// [SDLUI-1281] 상품문의 비노출 임시코드
/* eslint-disable no-confusing-arrow */
const qnaDisableDealList = [
  2645380094,
  2646457150,
  2646678206,
  2646784514,
  2646821978,
  2646856842,
  2646883922,
  2646891174,
  2646893690,
  2646897550,
  2646903818,
  2646904330,
  2646905114,
  2646906166,
  2646909670,
  2646915938,
  2646923294,
  2646926622,
  2646932542,
  2646936682,
  2646942010,
  2646948334,
  2646954842,
];

export const invisibleQnaStyle = () => {
  const {
    htStaticData: { htDealInfo },
  } = TMON.oApp.htStorage;

  return qnaDisableDealList.includes(htDealInfo.dealNo)
    ? 'style="display:none;"'
    : '';
};

export const invisibleQnaTabForPC = htTabInfo => {
  const {
    htStaticData: { htDealInfo },
  } = TMON.oApp.htStorage;

  if (qnaDisableDealList.includes(htDealInfo.dealNo)) {
    // eslint-disable-next-line no-param-reassign
    delete htTabInfo.qnaSection;
  }
};

export const invisibleQnaTabForMobile = (htTabInfo, reviewType) => {
  const {
    htStaticData: { htDealInfo },
  } = TMON.oApp.htStorage;

  if (!qnaDisableDealList.includes(htDealInfo.dealNo)) {
    return;
  }

  if (reviewType.data === 'N') {
    delete htTabInfo.review;
  } else {
    htTabInfo.review.name = '상품리뷰';
  }
};
